import { useIsFirstRun } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetCheckEstimationExists } from '../../../actions/checkEstimationExists';
import { selectFilters } from '../../../selectors/selectFilters';

/**
 * При изменении основных фильтров,
 * сбрасывает флаг отсутствия данных оценки и флаг наличия оценки у текущего юзера
 * */
export const useResetEstimExists = () => {
  const dispatch = useDispatch();
  const isFirstRun = useIsFirstRun();
  const { address, roomsCount, area } = useSelector(selectFilters);

  React.useEffect(() => {
    if (!isFirstRun) {
      dispatch(resetCheckEstimationExists());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, roomsCount, area, dispatch]);
};
